// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"90d027ae","248":"34c51553","429":"6354223e","431":"977eaf52","449":"5d65be32","641":"09580e95","655":"e8f78a60","659":"e6927c27","710":"99ebabfb","786":"47190f50","830":"960c5556"}[chunkId] + ".chunk.js";
};